export const GET_STATES = "GET_STATES";
export const UPDATE_STATE_STATUS = "UPDATE_STATE_STATUS";
export const ADD_STATE = "ADD_STATE";
export const UPDATE_STATE = "UPDATE_STATE";
export const GET_DISTRICTS_DATA = "GET_DISTRICTS_DATA";
export const UPDATE_DISTRICT_STATUS = "UPDATE_DISTRICT_STATUS";
export const ADD_DISTRICT = "ADD_DISTRICT";
export const UPDATE_DISTRICT = "UPDATE_DISTRICT";
export const GET_AREAS_DATA = "GET_AREAS_DATA";
export const UPDATE_AREA_STATUS = "UPDATE_AREA_STATUS";
export const ADD_AREA = "ADD_AREA";
export const UPDATE_AREA = "UPDATE_AREA";
